"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var category_convert_util_1 = require("./util/category-convert.util");
var path_helper_1 = require("./config/path.helper");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
* @author lilit.abrahamyan on 2/19/19.
*/
var HttpDataPointService = /** @class */ (function () {
    function HttpDataPointService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(path_helper_1.PathHelper.meServiceUriKey));
    }
    HttpDataPointService.prototype.create = function (dataPoint) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.DATAPOINT, dataPoint.toValidJson()); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendSaveResultToFrontendSaveResult(response); }));
    };
    HttpDataPointService.prototype.update = function (dataPoint) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.DATAPOINT, dataPoint.toValidJson()); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendSaveResultToFrontendSaveResult(response); }));
    };
    HttpDataPointService.prototype.delete = function (id) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.DATAPOINT + '/' + id); }));
    };
    HttpDataPointService.prototype.getById = function (id) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.DATAPOINT + '/' + id); }), operators_1.map(function (response) { return category_convert_util_1.ConvertUtil.backendDataPointToFrontendDataPoint(response); }));
    };
    HttpDataPointService.prototype.list = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.DATAPOINT); }), operators_1.map(function (response) {
            var dataPoints = [];
            response.forEach(function (res) {
                dataPoints.push(category_convert_util_1.ConvertUtil.backendDataPointToFrontendDataPoint(res));
            });
            return dataPoints;
        }));
    };
    HttpDataPointService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpDataPointService);
    return HttpDataPointService;
}());
exports.HttpDataPointService = HttpDataPointService;
//# sourceMappingURL=http-data-point.service.js.map